import { CommonService } from './../../shared/services/common-service';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, HostListener, OnChanges } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Observable } from 'rxjs/Observable';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { CookieNames, AuthTypes, BasicRoutes, ErrorCodes, ApiEndpoints, AlertMessages, PaymentSteps, redirectionPoints, PaymentModel } from '../constant';
import { LoginService } from '../login/services/login.service';
import { mobileValidator, emailValidator, LoginRedirectService } from '../../shared/'
import { CookieManagerService, CustomObserverService, ShoppingCartService, RegistrationFeeService, RegistrationFeeTokenService } from '../../shared/';
import { LocalStorageService } from 'angular-2-local-storage';
import { User, NewUser } from '../model'
import { AppLoginService } from './app-login.service';
import { LoginTypes } from '../constant';
import { SubscriptionInfoService } from '../subscription-packages/subscription-info-service.service';
import { debug } from 'util';

declare var $: any;
import swal from 'sweetalert2';

@Component({
  selector: 'login-component',
  templateUrl: './app-login.component.html',
})

export class AppLoginComponent implements OnInit {
  public authTypes = AuthTypes;
  public step: number = 0;
  public error: string = '';
  public error1: string = '';
  public error2: string = '';
  public errormsg: string = null;
  public success: string = '';
  private cuurentUrl: string = '';
  public imageProfile: any;
  public disableSendPinBtn: boolean = false;

  loginStep1: FormGroup;
  loginStep2: FormGroup;
  loginStep3: FormGroup;
  loginStep4: FormGroup;
  loginStep5: FormGroup;

  loginBody: any = {};
  loginModal: any;
  public ItemsToBuy: Array<any>;
  public billingDetails: boolean = true;
  public apiRequstWaiter: boolean = false;
  public nopassword: boolean = false;
  public isRegistrationFee: boolean = false;
  public token: any;
  public disablepswd: boolean = true;


  constructor(
    private loginService: LoginService,
    private cookieManagerService: CookieManagerService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private translateService: TranslateService,
    private registrationFeeTokenService: RegistrationFeeTokenService,
    private subscriptionInfoService: SubscriptionInfoService,

    private fb: FormBuilder,
    private customObserverService: CustomObserverService,
    private shoppingCartService: ShoppingCartService,
    private registrationFeeService: RegistrationFeeService,
    private loginRedirectService: LoginRedirectService,
    private commonService: CommonService
    // private RegistrationPaymenntMethodComponent: RegistrationPaymenntMethodComponent,
  ) {
    this.createForm();
  }

  createForm() {
    this.loginStep1 = this.fb.group({
      username: ['', Validators.compose([Validators.required, mobileValidator])],
    });

    this.loginStep2 = this.fb.group({
      password: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(30)])],
    });

    this.loginStep3 = this.fb.group({
      password: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(30)])],
      reenterpassword: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(30)])],
      verification: ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(6)])],
    });
    this.loginStep4 = this.fb.group({
      email: ['', Validators.compose([Validators.required, emailValidator])],
      username: ['', Validators.compose([Validators.required, mobileValidator])]
    });
    this.loginStep5 = this.fb.group({
    });
  }

  ngOnInit() {
    this.step = 1;
    this.errormsg = null;

  }

  ngAfterViewInit() {

    this.loginModal = $('#log-in-pop');
    this.modalOnHide();
    $(function () {
      $("#text-input").focus();
    });

  }

  /**
   * 
   * 
   * @param {any} data 
   * @memberof AppLoginComponent
   */
  enterUsername(data) {
    this.apiRequstWaiter = true;
    this.messageClear();
    this.loginBody.mobile = data.username;
    this.error1 = '';
    this.loginService.loginWithMobile(this.loginBody).subscribe(res => {
      this.apiRequstWaiter = false;
      (res.isUserExist && res.isVerified) ? this.step = 2 : ((!res.isVerified || !res.isUserExist) ? this.step = 3 : false);
      //res.isUserRegistered ? this.step = 3 : false;

    }, err => {
      let error = err.json();
      if (error.code == 40110) {
        this.error = this.translateService.instant('NOT_VERIFIED_USER')
      }
      else {
        this.error = this.translateService.instant('CHECK_MOBILE_NUMBER_TRYAGAIN');
      }
      this.apiRequstWaiter = false;
    });

  }

  /**
   * 
   * 
   * @param {any} data 
   * @memberof AppLoginComponent
   */
  login(data) {
    this.apiRequstWaiter = true;
    this.loginBody.verificationCode = data.verification;
    this.loginBody.password = data.password;
    this.error = '';
    var isDialogNumber = this.commonService.isDialogMobileNumber(this.loginBody.mobile);
    if (isDialogNumber) {
      this.customObserverService.setCurrentPaymentType(PaymentModel.Subscription);
      this.localStorageService.set(CookieNames.PaymentModel, PaymentModel.Subscription);
    }
    else {
      this.customObserverService.setCurrentPaymentType(PaymentModel.NonSubscription);
      this.localStorageService.set(CookieNames.PaymentModel, PaymentModel.NonSubscription);
    }
    this.loginService.loginWithMobile(this.loginBody).subscribe((res: any) => {
      res.isRegistrationFeePaid != null ? this.isRegistrationFee = res.isRegistrationFeePaid : this.isRegistrationFee = true;
      if (!res.token && !res.authorizationToken && !res.isVerificationCodeValied) {
        this.step = 3;
        this.error = this.translateService.instant('WRONG_CODE');
      } else {

        if (!this.isRegistrationFee) {
          this.token = res.paymentCode;
          this.registrationFeeService.setRegistrationTokenForFee(res.paymentCode);
          this.registrationFeeTokenService.setRegistrationToken(res.authorizationToken);
          this.localStorageService.set(CookieNames.userPackageId, res.user.subscriptionPackageId);
          this.cookieManagerService.setCookie(CookieNames.registrationToken, this.registrationFeeTokenService.getRegistrationToken());
          let redirectionPoint = this.loginRedirectService.getRedirectPoint();
          if (redirectionPoint == redirectionPoints.registration || redirectionPoint == redirectionPoints.mypapers || redirectionPoint == redirectionPoints.freePaper || !(redirectionPoint || false)) {
            this.router.navigate([BasicRoutes.registrationPayment]);
          } else if (redirectionPoint == redirectionPoints.billingInfo) {
            this.router.navigate([BasicRoutes.billingInfo]);
          }

        } else {
          this.loginAfter(res.user, res.token);
        }
        this.modalClose();
        this.cuurentUrl = this.router.url;
      }
      this.apiRequstWaiter = false;
    }, err => {
      this.apiRequstWaiter = false;
      let error = err.json();
      if (err && err.json() && err.json().body && err.json().body.message == "Wrong Pin" || (err.json().status && err.json().status == '401')) {
        this.error = this.translateService.instant('WRONG_CODE');
      } else {
        if (error.message == "password is not valid") {
          this.error = this.translateService.instant('WRONG_PASSWORD');
        }
        else if (error.code == 40110) {
          this.error = this.translateService.instant('INVALID_USER')
        } else {
          this.error = this.translateService.instant('WRONG_CODE');
        }
      }
    }
    );
  }

  /**
   * Save user login details on Cookies and Localstorage with given User object and tokens 
   * with returns from authenticate api
   * 
   * @param {User} user 
   * @memberof AppLoginComponent
   */
  loginAfter(user: User, token: any) {
    if (user && user.image) {
      this.imageProfile = user.image;
    } else {
      this.imageProfile = '/assets/img/default-avatar.svg';
    }
    //this.localStorageService.remove(CookieNames.userImage);
    this.localStorageService.set(CookieNames.userImage, this.imageProfile);
    if (user) {
      let userDetails = user;
      userDetails.image = '';
      this.cookieManagerService.setCookie(CookieNames.userobj, JSON.stringify(userDetails));
      this.cookieManagerService.setCookie(CookieNames.loginKey, AuthTypes.tokenPrefix + token, false);
      this.cookieManagerService.setCookie(CookieNames.loginType, LoginTypes.web, false);
      //subscriptionCount
      this.cookieManagerService.setCookie(CookieNames.subscriptionCount, user.paidSubscribeCount, false);
      this.customObserverService.setSubscriptionCount(user.paidSubscribeCount);

      this.localStorageService.set(CookieNames.loginType, LoginTypes.web);
      this.subscriptionInfoService.setCurrentSubscriptionPackage(user.subscriptionPackageId);
      if (user.subscriptionPackageId) {
        this.loginRedirectService.setRedirectPoint(redirectionPoints.subscriptionInfo);
      }

      this.customObserverService.setUserId(user._id);

      if (user.firstname) {
        this.customObserverService.setName(user.firstname);
      } else {
        this.customObserverService.setName(user.username);
      }
    }
    this.customObserverService.setData(this.imageProfile);
    this.modalClose();
    this.loginRedirection(user);
    // get all shopping cart details
    this.ItemsToBuy = this.shoppingCartService.allStorage();
    if (this.localStorageService.get(CookieNames.PaymentModel) == PaymentModel.NonSubscription) {

      // Put a comment on this since activate subscription model. When you use the paper price mdoel, this should be uncommented to get the cart details. 26/12/2018
      // PaperPricingModel Start --------------------------------------------------------------------------------------------
      // get ides array
      let cartItems = [];
      this.ItemsToBuy.forEach(item => { // need to check with item
        cartItems.push(item.id);
      });
      // call backend to get those items are bought or not
      // Put a comment on this since activate subscription model. When you use the paper price mdoel, this should be uncommented. 26/12/2018
      this.loginService.getGoingToBuyItemStatus(cartItems).subscribe(res => {
        let i = 0;
        res.forEach(element => { //freach the return value
          // if the item already bought
          if (element.isBought) {
            i++;
            this.shoppingCartService.removeItemsCheckout(element.item);
          }
        });
        //   // set the cookie for when one of the added item has been deleted
        if (i > 0) {
          this.cookieManagerService.setCookie(CookieNames.isRemoveCartItem, 'true', false);
          location.reload();
        }
      });
      // Put a comment on this since activate subscription model. When you use the paper price mdoel, this should be uncommented.26/12/2018
      // console.log('app-log-hi',this.cuurentUrl)
      this.router.navigate([this.cuurentUrl]);
      if (cartItems.length <= 0) {
        location.reload();
      }
    }
    // PaperPricingModel End --------------------------------------------------------------------------------------------
  }

  /**
   * bind hide event of modal
   * 
   * @memberof AppLoginComponent
   */
  modalOnHide() {
    let _this = this;
    this.loginModal.on('hide.bs.modal', function () {
      _this.step = 1;
      _this.loginStep1.reset();
      _this.loginStep2.reset();
      _this.loginStep3.reset();
      _this.messageClear();

    });
  }

  /**
   * modal close using hide event
   * 
   * @memberof AppLoginComponent
   */
  modalClose() {
    this.step = 1;
    this.errormsg = null;
    this.loginModal.modal('hide');
    this.messageClear();
    this.loginBody = {};
    let currentUrl = this.router.url;

    if (this.loginRedirectService.getIsClickedMyPapers()) {
      if (this.isRegistrationFee) {
        if (currentUrl == BasicRoutes.clientExams) {
          this.router.navigate([BasicRoutes.revisionPapers]);
        }
        else {
          this.router.navigate([BasicRoutes.clientExams]);
        }
      }
      this.loginRedirectService.cickedMyPapers(false);
    }


  }

  sendPinAgain() {
    this.disableSendPinBtn = true;
    this.resetPassword();
    let _this = this;
    setTimeout(function () {
      _this.disableSendPinBtn = false;
    }, 4000);

  }

  resetPassword() {
    let _this = this;
    _this.step = 3;
    _this.messageClear();
    this.loginService.resetPassword(this.loginBody.mobile).subscribe(res => {
      _this.loginStep2.reset();
    }, err => {
      if (err && err._body && JSON.parse(err._body).acode == 40110) {
        _this.error = _this.translateService.instant('NOT_VERIFIED_USER');
      }
      else {
        _this.error = _this.translateService.instant('TRY_AGAIN');
      }
    });
  }

  messageClear() {
    this.error = null;
    this.success = null;
  }

  backToPhoneNumber() {
    this.step = 1;
    this.errormsg = null;
    this.messageClear();
    this.loginStep3.reset();
    this.loginStep2.reset();
    this.loginBody = {};
  }

  clearInvalidPwdMsg(txt) {
    if (txt.target.value.length == 0) {
      this.messageClear();
    }
  }

  public userDetails: NewUser = new NewUser({});

  loginRedirection(user) {
    let redirectionPoint = this.loginRedirectService.getRedirectPoint();
    if (redirectionPoint == redirectionPoints.billingInfo) {
      if ((user || false).isDistrictNeed) {
        this.customObserverService.setPaymentFlowIcon(PaymentSteps.billingDetails);
        this.router.navigate([BasicRoutes.billingInfo]);
      }
      else {
        this.customObserverService.setPaymentFlowIcon(PaymentSteps.paymentOptions);
        this.router.navigate([BasicRoutes.paymentOptions]);
      }
    }
    else if (redirectionPoint == redirectionPoints.mypapers) {
      this.router.navigate([BasicRoutes.mypapers]);
    }
    else if (redirectionPoint == redirectionPoints.subscriptionInfo) {
      // let subscribedPackageId = this.subscriptionInfoService.getUserSubscribedPackage();
      // let selectedPackage = this.subscriptionInfoService.getSelectedPackage();
      if (this.router.url === "/") {
        this.router.navigate([BasicRoutes.mypapers]);
      }
      // else if(this.router.url=== BasicRoutes.clientExams || this.router.url=== BasicRoutes.revisionPapers){
      else {
        this.subscriptionInfoService.toggleSubscriptionPopup();

      }
      // if(selectedPackage && selectedPackage._id === subscribedPackageId){
      //   swal({
      //     title: this.translateService.instant('INFORMATION'),
      //     html: this.translateService.instant('ALREADY_SUBSCRIBED_ERROR'),
      //     type: 'success'
      //   });
      //   if(selectedPackage.subscriptionType !='FREE'){
      //     this.router.navigate([BasicRoutes.mypapers]);
      //   } 
      //   else{
      //     this.router.navigate([BasicRoutes.clientExams]);
      //   }

      // }
      // else{
      //   if(subscribedPackageId && selectedPackage && selectedPackage.subscriptionType ==='FREE'){
      //     swal({
      //       title: this.translateService.instant('INFORMATION'),
      //       html: this.translateService.instant('ALREADY_SUBSCRIBED_ERROR'),
      //       type: 'success'
      //     });
      //     this.router.navigate([BasicRoutes.mypapers]);
      //   }
      //   else{
      //     this.router.navigate([BasicRoutes.mypapers]);
      //   }
      // }
    }
    else if (redirectionPoint == redirectionPoints.freePaper) {
      let redirectionPaper = this.loginRedirectService.getRedirectPaper();
      if (redirectionPaper) {
        this.router.navigate([redirectionPaper]);
      }
    }
    else if (redirectionPoint == null || redirectionPoint == "registration") {
      this.router.navigate([BasicRoutes.clientExams]);
    }
    else {
      this.router.navigate([BasicRoutes.clientExams]);
    }
  }

  existingUser() {
    let _this = this;
    this.loginBody = {};
    _this.loginStep4.reset();
    this.apiRequstWaiter = false;
    this.step = 4;
    this.messageClear();

  }

  getMobilePassword(val) {
    this.errormsg = null;
    this.loginBody.mobile = val.username;
    this.loginBody.email = val.email;
    this.loginService.loginExistingEmail(this.loginBody).subscribe(res => {
      if (res.isUserExist) {
        this.step = 1;
        // this.withMobile = true;
        this.errormsg = this.translateService.instant('WITHMOBILE');
      } else {
        res.isMobile ? this.step = 3 : false;
      }
      this.apiRequstWaiter = false;
    }, err => {
      let error = err.json();
      if (error.code == '40161') {
        this.errormsg = this.translateService.instant('USERMIGRATED');
      } else if (error.code == '4016') {
        this.errormsg = this.translateService.instant('USERNOTEXISTING');
      } else if (error.code == '4017') {
        this.errormsg = this.translateService.instant('NOUSEREMAIL');
      } else {
        this.nopassword = true;

      }
      this.step = 1;
      this.apiRequstWaiter = false;
    });
  }

  repeatPasswordMatch(user) {
    if (user.password && user.password.length >= 6 && user.reenterpassword && user.reenterpassword.length >= 6 && user.password == user.reenterpassword && user.verification) {
      this.error2 = null;
      this.disablepswd = false;
    } else if (user.password && user.reenterpassword && user.password != user.reenterpassword) {
      this.error2 = this.translateService.instant('PASSWORD_NOT_MATCH');
      this.disablepswd = true;
    }
    else {
      if (user.password && user.password.length < 6 && user.reenterpassword && user.reenterpassword.length < 6) {
        this.error2 = this.translateService.instant('PASSWORD_MINIMUM');;
      }
      else {
        this.error2 = null;
      }
      this.disablepswd = true;
    }


  }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/app-login/app-login.component.ts